;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { TrackingDestination } from '@qogita/tracking'
import { browserLogger } from 'src/core/logger/browser'

import { SellersBrowserTrackingEventList } from '../../types'

const GOOGLE_ADS_CONVERSION_ID = 'AW-628038862'
const SIGN_UP_SUBMITTED_CONVERSION_LABEL = 'hBo7CIrRpfgYEM65vKsC'

function gtagConversion(conversionLabel: string) {
  if (!window.gtag) {
    browserLogger.warn('gtag is not defined, skipping conversion', {
      conversionLabel,
    })
    return
  }
  window.gtag('event', 'conversion', {
    send_to: `${GOOGLE_ADS_CONVERSION_ID}/${conversionLabel}`,
  })
}

export const gtagDestination =
  new TrackingDestination<SellersBrowserTrackingEventList>({
    eventHandlers: {
      'Sign Up Submitted': () => {
        gtagConversion(SIGN_UP_SUBMITTED_CONVERSION_LABEL)
      },
    },
  })
